import React, { useContext, useEffect, useState } from 'react'
import { StateController } from './../../App'
import TestQuestions from '../organisms/TestQuestions'
import { sendDataLayer } from '../../utils/functions';
import useWidth from '../../hooks/useWidth';

function MajorAward() {
  const { context } = useContext(StateController)
    const { width } = useWidth();
  //const segment = context?.user?.segment ? context.user.segment : '0';

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 998);
    };
    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

    const click_tyc = () => {
      sendDataLayer({ datalayer: ({ 
          event: "terms_conditions_grandprize", 
          text: "consulta los detalles aqui.", 
          link: "/GanaConMastercardDebit/terminos-y-condiciones", 
          site_url: window.location.href }), 
      repeat: true })
  }


  return (
    <div className='mc-page majorAward slow_ani'>

      {
        <div className='container-majorAward'>
        {
          !isMobile ? (
            <div className='banner-one'>
              <div className="banner-major-award">
                <div className='text-major-award-container'>
                  <div className='title-container'>
                    <h1 className='title'>
                      ¡Llévate <br />el premio mayor!
                    </h1>
                    <span>Con tu Tarjeta de Débito Mastercard, gana un <strong>viaje doble a Turquía.</strong></span>
                  </div>
                  <div className='info-container'>
                    <div className='sub-title-container'>
                      {/* <h2 className='subtitle'>¿Como se seleccionará <br />
                        <span> a los ganadores de estos premios?</span></h2> */}
                    </div>
                    {/* <div className='paragraph-container'>
                      <p className='paragraph'>Se seleccionará al azar a un (1) ganador que recibirá como premio <span>dos tiquetes de avión para viajar a
                        Río de Janeiro, Brasil.</span></p>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className='banner-one'>
              <div className="banner-major-award">
                <div className='text-major-award-color'>
                  <div className='title-container'>
                    <h1 className='title'>
                      ¡Llévate <br />el premio mayor!
                    </h1>
                    <span>Con tu Tarjeta de Débito Mastercard, gana un <strong>viaje doble a Turquía.</strong></span>
                  </div>
                </div>
                <div className='text-major-award-nocolor'>
                  <div className='info-container'>
                    <div className='sub-title-container'>
                      {/* <h2 className='subtitle'>¿Como se seleccionará <br />
                        <span> a los ganadores de estos premios?</span></h2> */}
                    </div>
                    <div className='paragraph-container'>
                      {/* <p className='paragraph'>Se seleccionará al azar a un (1) ganador que recibirá como premio <span>dos tiquetes de avión para viajar a <br />
                        Río de Janeiro, Brasil.</span></p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        }
        <div className='container-banner-two'>
          <div className='container-text-banner-two'>
            <h2>¿Qué incluye?</h2>
            <p className='subtitle'><strong className='subtitle_strong'>Duración: 8 días / 7 noches</strong></p>

            <div>
              <span className='point-pink'>. </span><span className='title-strong'><strong>Vuelos</strong></span>
              <ul>
                <li>Internacional:<br/>Quito o Guayaquil - Estambul - Quito o Guayaquil</li>
                <li>Doméstico:<br/>Capadocia - Estambul (incluye 1 maleta de 15 kg)</li>
              </ul>
            </div>

            <div>
              <span className='point-pink'>. </span><span className='title-strong'><strong>Transporte privado:</strong></span>
              <ul>
                <li>Aeropuerto - hotel - aeropuerto.</li>
              </ul>
            </div>

            <div>
              <span className='point-pink'>. </span><span className='title-strong'><strong>Alojamiento 7 noches:</strong></span>
              <ul>
                <li>4 noches en Estambul</li>
                <li>1 noche en Ankara</li>
                <li>2 noches en Capadocia</li>
              </ul>
            </div>

            <div>
              <span className='point-pink'>. </span><span className='title-strong'><strong>Experiencias incluidas:</strong></span>
              <ul>
                <li>Mezquita de Solimán el Magnífico, Estambul</li>
                <li>Paseo en barco por el Bósforo</li>
                <li>Bazar de las Especias</li>
                <li>Entradas y visitas según itinerario</li>
                <li>Guía en español</li>
                <li>Asistencia al viajero 24/7</li>
              </ul>
            </div>

            <div>
              <span className='point-pink'>. </span><span className='title-strong'><strong>No incluye:</strong></span>
              <ul>
                <li>Alimentos y bebidas no especificados</li>
                <li>Tasas hoteleras en destino: USD 15 por persona</li>
                <li>Propinas: USD 30 por persona</li>
                <li>Excursiones opcionales</li>
                <li>Gastos personales</li>
              </ul>
            </div>

          </div>
          <div className='container-img-banner-two'>
            {width > 998 ? (
              <img src="/assets/images/premio_mayor_img_1.png" alt="" />
            ) : (
              <img src="/assets/images/premio_mayor_img_1_mb.png" alt="" />
            )}
          </div>
        </div>

        <div className="container-banner-three">
          <div className='container-img-banner-three'>
            {width > 998 ? (
              <img src="/assets/images/premio_mayor_img_2.png" alt="" />
            ) : (
              <img src="/assets/images/premio_mayor_img_2_mb.png" alt="" />
            )}
          </div>
          <div className='container-text-banner-three'>
            <h2>¿Cómo podrás participar <br />
              <span>por este premio?</span></h2>
            <p>Cada vez que cumplas tu meta, sumas una oportunidad para ganarte un viaje a Turquía para dos personas.</p>
            <p><strong>Acumula hasta 5 oportunidades</strong> y aumenta tus posibilidades de ganar.</p>
            <p className='terms'>*Aplican Términos y Condiciones, <a onClick={click_tyc} href="/GanaConMastercardDebit/terminos-y-condiciones">consulta los detalles.</a></p>
          </div>
        </div>

        <div className="container-banner-three del2">
          <div className='container-text-banner-three del2'>
            <h2>¿Como se elige el <span>ganador de este premio?</span></h2>
            <p><b>Se sorteará un (1) premio</b> entre todos los participantes que hayan cumplido su meta y tengan oportunidades acumuladas.</p>
          </div>
        </div>

      </div>
      
      }


      {
        context && context.quiz && (context.quiz.length === 0 || context.quiz.every(q => q.response_3 === null)) &&
        <TestQuestions context={context} quizNumber={2} />
      }
    </div >
  )
}
export default MajorAward